import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { getAdminUser } from '../../services/adminManagementServices';
import { AppDispatch } from '../../core/data/redux/store';
import { Breadcrumb, Card, Button, Tag, Typography, Row, Col, Space } from 'antd';
import * as Icon from 'react-feather';

const { Title, Text, Paragraph } = Typography;

const AdminDetail = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { adminUser, isLoading, isError, errorMessage } = useSelector((state: any) => state.adminManagement);

  useEffect(() => {
    if (id) {
      dispatch(getAdminUser(id));
    }
  }, [dispatch, id]);

  if (isLoading) return <Card loading style={{ margin: 24 }} />;
  if (isError) return <Card style={{ margin: 24 }}><Text type="danger">{errorMessage}</Text></Card>;
  if (!adminUser) return <Card style={{ margin: 24 }}><Text>Admin user not found</Text></Card>;

  return (
    <div className="page-wrapper page-settings" style={{ paddingTop: 0 }}>
      <div className="content">
        <Breadcrumb style={{ marginBottom: 20 }}>
          <Breadcrumb.Item>
            <Link to="/admin/admin-management">Admin Management</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/admin/admin-management/list-admins">List Admins</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Admin Detail</Breadcrumb.Item>
        </Breadcrumb>
        <Card>
          <Title level={4} style={{ marginBottom: 24 }}>Admin User Details</Title>
          <Row gutter={[24, 24]}>
            <Col xs={24} md={12}>
              <Title level={5}>Basic Information</Title>
              <Paragraph><Text strong>Username:</Text> {adminUser.username}</Paragraph>
              <Paragraph><Text strong>Full Name:</Text> {adminUser.full_name}</Paragraph>
              <Paragraph><Text strong>Email:</Text> {adminUser.email_address || 'N/A'}</Paragraph>
              <Paragraph><Text strong>Phone:</Text> {adminUser.phone_number}</Paragraph>
              <Paragraph>
                <Text strong>Role:</Text> <Tag color={adminUser.role === 'SUPER_ADMIN' ? 'red' : adminUser.role === 'ADMIN' ? 'gold' : 'blue'}>{adminUser.role}</Tag>
              </Paragraph>
            </Col>
            <Col xs={24} md={12}>
              <Title level={5}>Account Status</Title>
              <Paragraph>
                <Text strong>Status:</Text> <Tag color={adminUser.is_active ? 'green' : 'red'}>{adminUser.is_active ? 'Active' : 'Inactive'}</Tag>
              </Paragraph>
              <Paragraph>
                <Text strong>Verified:</Text> <Tag color={adminUser.is_verified ? 'green' : 'orange'}>{adminUser.is_verified ? 'Yes' : 'No'}</Tag>
              </Paragraph>
              <Paragraph>
                <Text strong>Notifications:</Text> <Tag color={adminUser.is_notification_allowed ? 'green' : 'default'}>{adminUser.is_notification_allowed ? 'Allowed' : 'Blocked'}</Tag>
              </Paragraph>
              <Paragraph><Text strong>Created:</Text> {new Date(adminUser.created_at).toLocaleDateString()}</Paragraph>
              <Paragraph><Text strong>Updated:</Text> {new Date(adminUser.updated_at).toLocaleDateString()}</Paragraph>
            </Col>
          </Row>
          {adminUser.biography && (
            <Row style={{ marginTop: 24 }}>
              <Col span={24}>
                <Title level={5}>Biography</Title>
                <Paragraph>{adminUser.biography}</Paragraph>
              </Col>
            </Row>
          )}
          <Row style={{ marginTop: 24 }} gutter={[16, 16]}>
            <Col xs={24} md={8}>
              <Card bordered={false} style={{ background: '#f0f5ff' }}>
                <Title level={5}>Vote Streak</Title>
                <Title level={3}>{adminUser.vote_streak_count}</Title>
              </Card>
            </Col>
            <Col xs={24} md={8}>
              <Card bordered={false} style={{ background: '#f6ffed' }}>
                <Title level={5}>Poll Streak</Title>
                <Title level={3}>{adminUser.poll_streak_count}</Title>
              </Card>
            </Col>
            <Col xs={24} md={8}>
              <Card bordered={false} style={{ background: '#fffbe6' }}>
                <Title level={5}>Karma Points</Title>
                <Title level={3}>{adminUser.karma_point}</Title>
              </Card>
            </Col>
          </Row>
          <Space style={{ marginTop: 32 }}>
            <Link to="/admin/admin-management/list-admins">
              <Button>Back to List</Button>
            </Link>
            <Link to={`/admin/admin-management/update-admin-role/${adminUser.id}`}>
              <Button type="primary" icon={<Icon.Edit size={16} />}>Update Role</Button>
            </Link>
          </Space>
        </Card>
      </div>
    </div>
  );
};

export default AdminDetail; 